function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import _pt from "prop-types";
var _excluded = ["id", "isFull", "labelVisual", "labelA11y", "labelStyle", "labelAsHeading", "labelTag", "instructions", "disableMargins", "messages", "messagesRole", "className", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React, { useEffect } from 'react';
import classNames from 'classnames';
import { Heading } from '@lmig/lmds-react-typography';
import { FieldGroupMessages } from './FieldGroupMessages';
import "./fieldGroup.css";
var deprecatedLabelStyles = {
  bodytext: 'h6-small',
  'bodytext-article': 'h6',
  'bodytext-lead': 'h5'
};
var isLabelStyleDeprecated = function isLabelStyleDeprecated(labelStyle) {
  return Object.keys(deprecatedLabelStyles).includes(labelStyle);
};
export var FieldGroup = function FieldGroup(_ref) {
  var id = _ref.id,
    isFull = _ref.isFull,
    labelVisual = _ref.labelVisual,
    labelA11y = _ref.labelA11y,
    _ref$labelStyle = _ref.labelStyle,
    labelStyle = _ref$labelStyle === void 0 ? 'h4' : _ref$labelStyle,
    labelAsHeading = _ref.labelAsHeading,
    _ref$labelTag = _ref.labelTag,
    labelTag = _ref$labelTag === void 0 ? 'span' : _ref$labelTag,
    instructions = _ref.instructions,
    disableMargins = _ref.disableMargins,
    messages = _ref.messages,
    _ref$messagesRole = _ref.messagesRole,
    messagesRole = _ref$messagesRole === void 0 ? 'status' : _ref$messagesRole,
    className = _ref.className,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  useEffect(function () {
    if (labelAsHeading && process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn('The `labelAsHeading` prop on FieldGroup is deprecated and will be removed in the next major release. Please use the `labelTag` prop instead. See https://designsystem.lmig.com/components/form/field-group/code for documentation.');
    }
  }, [labelAsHeading]);
  useEffect(function () {
    if (Object.keys(deprecatedLabelStyles).includes(labelStyle) && process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn("The `".concat(labelStyle, "` value for FieldGroup's `labelStyle` prop is deprecated and will be removed in the next major release. Please use `deprecatedLabelStyles[labelStyle]` instead. See https://designsystem.lmig.com/components/form/field-group/code for documentation."));
    }
  }, [labelStyle]);
  var renderLabels = function renderLabels() {
    if (!labelVisual && !labelA11y && !instructions) {
      return null;
    }
    var labelVisualNode;
    if (labelVisual) {
      // when we remove the deprecated bodytext labelStyles, labelStyle can be passed directly to type
      var typeStyle = isLabelStyleDeprecated(labelStyle) ? deprecatedLabelStyles[labelStyle] : labelStyle;
      labelVisualNode = /*#__PURE__*/React.createElement(Heading, {
        className: classNames('lm-FieldGroup-name', _defineProperty({}, "".concat(className, "-name"), className)),
        type: typeStyle,
        tag: labelAsHeading ? undefined : labelTag,
        ariaHidden: !!labelA11y
      }, labelVisual);
    }
    var labelA11yNode;
    if (labelA11y) {
      labelA11yNode = /*#__PURE__*/React.createElement("span", {
        className: "lm-a11yOnly"
      }, labelA11y);
    }
    var instructionsNode;
    if (instructions) {
      instructionsNode = /*#__PURE__*/React.createElement("span", {
        className: "lm-FieldGroup-instruct"
      }, instructions);
    }
    return /*#__PURE__*/React.createElement("div", {
      className: classNames('lm-FieldGroup-label', _defineProperty({}, "".concat(className, "-label"), className))
    }, labelVisualNode, labelA11yNode, instructionsNode);
  };
  var classes = classNames('lm-FieldGroup', {
    'lm-FieldGroup--is-full': isFull
  }, _defineProperty({}, "lm-FieldGroup--disable-margin-".concat(disableMargins), disableMargins), className);
  return /*#__PURE__*/React.createElement("div", _extends({
    id: id,
    className: classes
  }, otherProps), renderLabels(), /*#__PURE__*/React.createElement(FieldGroupMessages, {
    className: className && "".concat(className, "-messages"),
    messages: messages,
    role: messagesRole
  }), children);
};
FieldGroup.propTypes = {
  /** Add an optional ID to this element: `<div class="lm-FieldGroup">`. */id: _pt.string,
  /** Add custom classes to this element: `<div class="lm-FieldGroup">`. */className: _pt.string,
  /** By default, the FieldGroup element has a max-width of 600px, this boolean removes the width restriction. */isFull: _pt.bool,
  /** The text that appears above the FieldGroup. */labelVisual: _pt.node,
  /** Used with screen readers, optional: this text will replace the `labelVisual` in audio guidance. */labelA11y: _pt.string,
  /** Default style for the labelVisual, for more information visit the Typography > Headings page.
     * @default 'h4'
     */
  labelStyle: _pt.oneOf(['h1-large', 'h1', 'h2', 'h2-bold', 'h2-medium', 'h2-light', 'h3', 'h3-bold', 'h3-medium', 'h3-light', 'h4', 'h4-bold', 'h4-medium', 'h4-light', 'h5', 'h5-bold', 'h5-medium', 'h6', 'h6-bold', 'h6-medium', 'h6-small', 'h6-small-bold', 'h6-small-medium']),
  /**
     * Use `labelTag`.
     * When true, the text above this group will render in a semantic heading tag (e.g., <h4>) instead of a span.
     * @deprecated
     */
  labelAsHeading: _pt.bool,
  /** Specify the HTML tag if it should be different from the default tag set by `labelStyle`.
     * @default 'span'
     */
  labelTag: _pt.oneOf(['span', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  /** Optional, instructional text will appear below the labelVisual. */instructions: _pt.node,
  /** Groups messages above the field group by type.
     * An array of message type/text objects can be passed to the component. */
  messages: _pt.array,
  /**
     * Sets the screen reader alert role for all messages.
     * Use `status` for polite (non-interruptive) experience or `alert` for an assertive experience.
     * @default 'status'
     */
  messagesRole: _pt.oneOf(['status', 'alert']),
  /** Disables the top, bottom, or both top and bottom margins for spacing purposes. */disableMargins: _pt.oneOf(['all', 'top', 'bottom']),
  /** Pass form elements as children (e.g., AlphanumericInput, CheckboxGroup, Select, etc.). Children render inside `<div class="lm-FieldGroup">` */children: _pt.node
};